 document.addEventListener("DOMContentLoaded", function () {
        const showMoreStoryBtnMobile = document.querySelectorAll(
          "#showMoreStoryBtnMobile"
        );
        const storyOverlay = document.querySelector(
          ".fum-story-gradient-overlay-bottom"
        );
        const storyContainer = document.querySelector(".fum-story-container");

        showMoreStoryBtnMobile.forEach((btn) => {
          btn.addEventListener("click", function () {
            toggleStoryOverlay(storyContainer, storyOverlay);
          });
        });

        function toggleStoryOverlay(storyContainer, storyOverlay) {
          if (storyOverlay.style.display === "none") {
            storyOverlay.style.display = "flex";
            storyContainer.style.height = "100vh";
            storyContainer.style.overflow = "hidden";

            // Scroll to the top of the component (container)
            storyContainer.scrollIntoView({ behavior: "smooth" });
          } else {
            storyOverlay.style.display = "none";
            storyContainer.style.height = "100%";
            storyContainer.style.overflow = "auto";

            // Scroll to the third card
          }
        }
      });